type Key = string | number

export const indexArray = <T, K extends keyof T>(
  arr: readonly T[],
  key: K | ((item: T) => Key),
): Record<Key, T> => {
  const keyGetter = typeof key === 'function' ? key : (item: T) => item[key] as unknown as Key
  return arr.reduce<Record<Key, T>>((acc, item) => {
    acc[keyGetter(item)] = item
    return acc
  }, {})
}
